module.exports = __webpack_public_path__ + "static/media/IMG_1375_cropped.7ca9e171.jpg";